import { render, staticRenderFns } from "./DelMenu.vue?vue&type=template&id=ce07d874&scoped=true"
import script from "./DelMenu.vue?vue&type=script&lang=js"
export * from "./DelMenu.vue?vue&type=script&lang=js"
import style0 from "./DelMenu.vue?vue&type=style&index=0&id=ce07d874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce07d874",
  null
  
)

export default component.exports